import { useQuery } from "@tanstack/react-query";
import api from "@/lib/axios";
import { SalesByClient, SalesByClientSearchParams } from "@/interface/settlement/salesByClient";

/**
 * 거래처별 매출액 명세서 조회 API
 */
const fetchSalesByClient = async (params: SalesByClientSearchParams): Promise<SalesByClient[]> => {
  const { data } = await api.get("/sale-slip/sales-by-client", {
    params: {
      ...params,
      exactMatch: params.exactMatch || false,
    },
  });
  return data.data || [];
};

/**
 * 거래처별 매출액 명세서 조회 훅
 */
export const useSalesByClient = (params: SalesByClientSearchParams) => {
  return useQuery({
    queryKey: ["salesByClient", params],
    queryFn: () => fetchSalesByClient(params),
    enabled: !!params.startDate && !!params.endDate,
  });
};
